import { NOTE_CONTENT_SECTION_KEYS } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/initial-f2f/initial-f2f-constant";

/** Printed once in the common report header, so the note body skips it. */
export const SUMMARY_SKIPPED_SECTION_KEYS: string[] = ["chiefComplaints"];

export const SUMMARY_EXTRA_NOTE_SECTIONS: Record<
  string,
  { noteKey: string; label: string }[]
> = {
  medication: [
    {
      noteKey: NOTE_CONTENT_SECTION_KEYS.pharmacy,
      label: "Preferred Pharmacy",
    },
  ],
};

export const SUMMARY_FREE_TEXT_SUFFIX = " – Notes";
